import { useQuery } from '@tanstack/react-query';
import { config } from '@/lib/env';
import { extractMidPrice, getMarkets } from '@/services/api/market-maker';

const PRICE_POLL_INTERVAL_MS = 5_000;

/**
 * 5 s mid-price poll for the New Simulation dialog:
 * immediate fetch when enabled or the market changes; any failure, a disabled
 * dialog or an empty market all yield `null` (read errors are deliberately
 * silent — no toast, no error state, exactly like the legacy composable).
 */
export const useMidPrice = (market: string, enabled: boolean): number | null => {
  const isActive = enabled && market !== '' && Boolean(config.MARKET_MAKER_BASE_URL);
  const query = useQuery({
    queryKey: ['market-maker', 'price', market],
    queryFn: async () => extractMidPrice(await getMarkets(), market),
    enabled: isActive,
    refetchInterval: PRICE_POLL_INTERVAL_MS,
  });
  if (!isActive || query.isError) return null;
  return query.data ?? null;
};
